import Input from '../common/Input'
import Select from '../common/Select'
import { PLATFORMS } from '../../utils/websiteHelpers'

const WebsiteConnectionCreateForm = ({ register, errors, selectedPlatform }) => {
  const shouldShowApiKey = selectedPlatform !== 'shopify'

  return (
    <form className="space-y-4">
      <Select
        label="Platform"
        options={PLATFORMS}
        {...register('platform')}
        value={selectedPlatform}
        error={errors.platform?.message}
      />
      <Input label="Site Name" {...register('siteName')} error={errors.siteName?.message} />
      <Input
        label="Site URL"
        type="url"
        placeholder={selectedPlatform === 'shopify' ? 'https://your-store.myshopify.com' : 'https://example.com'}
        {...register('siteUrl')}
        error={errors.siteUrl?.message}
      />
      {shouldShowApiKey && (
        <Input
          label="API Key"
          type="text"
            placeholder="ada_abc123xyz..."
          {...register('apiKey')}
          error={errors.apiKey?.message}
        />
      )}
    </form>
  )
}

export default WebsiteConnectionCreateForm
